<template>
  <section>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="section">
      <h1 class="has-text-centered title">Your Upcoming Events</h1>
    </div>
    <div class="content" v-if="!loading">
      <div class="columns is-multiline events-grid">
        <div
          v-for="entry in myUpcomingEvents"
          :key="entry._id"
          class="column is-4"
        >
          <EventCard :entry="entry" :event="entry.event" :user="user" />
        </div>
      </div>
      <div class="has-text-centered">
        <p v-if="myUpcomingEvents.length === 0">
          You don't have any upcoming events.
        </p>
        <a
          class="button button-cta primary-btn rounded m-t-lg m-b-lg"
          href="/events"
          >Other Upcoming Events</a
        >
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EventCard from "@/components/EventCard";
export default {
  name: "Home",
  components: {
    EventCard,
  },
  data() {
    return {
      loading: true,
    };
  },
  async created() {
    await this.getMyUpcomingEvents();
    this.loading = false;
  },
  computed: {
    ...mapGetters(["myUpcomingEvents", "user"]),
  },
  methods: {
    ...mapActions(["getMyUpcomingEvents"]),
  },
};
</script>